import { useState } from 'react';
import clsx from 'clsx';

export function TagInput({ label, value = [], onChange, placeholder = 'Aggiungi e premi Invio', error, hint, lowercase = false }) {
  const [draft, setDraft] = useState('');

  // Accept one or many tags at once: a raw string is split on commas and
  // newlines, so typing/pasting "premium, no-cereali" yields two tags.
  const add = (raw) => {
    const parts = String(raw)
      .split(/[,\n]/)
      .map((p) => (lowercase ? p.toLowerCase() : p).trim())
      .filter(Boolean);
    if (!parts.length) return;
    const next = [...value];
    for (const p of parts) if (!next.includes(p)) next.push(p);
    if (next.length !== value.length) onChange(next);
    setDraft('');
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      add(draft);
    } else if (e.key === 'Backspace' && draft === '' && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  // Paste of a comma-separated list splits into multiple tags in one go.
  const handlePaste = (e) => {
    const text = e.clipboardData.getData('text');
    if (text && /[,\n]/.test(text)) {
      e.preventDefault();
      add(text);
    }
  };

  const remove = (v) => onChange(value.filter((x) => x !== v));

  return (
    <div className="flex flex-col gap-1.5">
      {label && <span className="text-sm font-medium text-ink">{label}</span>}
      <div
        className={clsx(
          'flex flex-wrap items-center gap-1.5 rounded-md border bg-surface-elevated px-2 py-1.5',
          error ? 'border-danger' : 'border-border'
        )}
      >
        {value.map((v) => (
          <span key={v} className="inline-flex items-center gap-1 rounded-md bg-border/40 px-2 py-0.5 text-xs">
            {v}
            <button type="button" onClick={() => remove(v)} className="text-ink-muted hover:text-danger" aria-label="Rimuovi">×</button>
          </span>
        ))}
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={handleKey}
          onPaste={handlePaste}
          onBlur={() => add(draft)}
          placeholder={value.length === 0 ? placeholder : ''}
          className="min-w-[120px] flex-1 bg-transparent text-sm text-ink placeholder:text-ink-faint focus:outline-none"
        />
      </div>
      {error ? <span className="text-xs text-danger">{error}</span> : hint ? <span className="text-xs text-ink-muted">{hint}</span> : null}
    </div>
  );
}
